import React, { useEffect } from 'react'
import { Icon as ErrorIcon } from 'images/other-error.svg'
import { Icon as Error500Icon } from 'images/500-error.svg'
import PropTypes from 'prop-types'
import { WorkFlowHeader, SupportModal } from 'components'
import { useHistory, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import { useAuth0 } from '@auth0/auth0-react'
import { selectors as globalSelectors } from './reducer'
import * as globalActions from './actions'
import { clearSessionToken } from 'auth'

const propTypes = {
  errorType: PropTypes.oneOf(['error', '403', '404']),
  supportModalShown: PropTypes.bool.isRequired,
  setSupportModalShown: PropTypes.func.isRequired,
}

const defaultProps = {
  errorType: null,
}

function ErrorPage({
  errorType: errorTypeProp,
  supportModalShown,
  setSupportModalShown,
}) {
  const history = useHistory()
  const location = useLocation()
  const { logout } = useAuth0()

  const ERROR_CONFIGS = {
    error: {
      title: 'Something went wrong',
      message: 'Try again in a moment or refresh the page.',
      action: 'Reload Page',
      onClick: () => {
        const params = new URLSearchParams(window.location.search)
        const from = params.get('from')
        if (from) {
          window.location.href = from
        } else {
          window.location.href = '/home'
        }
      },
      icon: Error500Icon,
    },
    403: {
      title: 'Access Denied',
      message:
        "We're unable to process your request. Return to the home page or contact support if you believe this is an error.",
      action: 'Return to Login',
      onClick: () => {
        clearSessionToken()
        logout({
          logoutParams: { returnTo: window.location.origin },
        }).catch(() => {})
      },
      icon: ErrorIcon,
    },
    404: {
      title: 'Page Not Found',
      message: "The page you are looking for doesn't exist or has been moved.",
      action: 'Home',
      onClick: () => history.push('/'),
      icon: ErrorIcon,
    },
  }

  const queryParams = new URLSearchParams(location.search)
  const errorTypeFromUrl = queryParams.get('type')

  // Use prop if provided, otherwise use URL param, otherwise default to 'error'
  const errorType = errorTypeProp || errorTypeFromUrl || 'error'

  const config = ERROR_CONFIGS[errorType] || ERROR_CONFIGS['error']
  const IconComponent = config.icon

  useEffect(() => {
    window.appEventData.pop()
    var appEventData = window.appEventData || []
    appEventData.push({
      event: 'Page Load Completed',
      errorType,
    })
  }, [errorType])

  const handleClick = () => {
    if (config.onClick) {
      config.onClick()
    }
  }

  return (
    <>
      <WorkFlowHeader title="" />
      <div id="error-page-container">
        <div className="error-state">
          <IconComponent aria-hidden="true" />
          <h1 className="error-state__title">{config.title}</h1>
          <p className="error-state__description">{config.message}</p>

          {config.action && (
            <button
              type="button"
              className="button-primary"
              onClick={handleClick}
            >
              {config.action}
            </button>
          )}
        </div>
      </div>

      {supportModalShown && (
        <SupportModal onClose={() => setSupportModalShown(false)} />
      )}
    </>
  )
}

const mapStateToProps = (state) => ({
  supportModalShown: globalSelectors.supportModalShown(state),
})

const mapDispatchToProps = {
  setSupportModalShown: globalActions.setSupportModalShown,
}

ErrorPage.propTypes = propTypes
ErrorPage.defaultProps = defaultProps

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage)
